module.exports = __webpack_public_path__ + "img/501bb94.png";